import { SITE } from "@/config";
import { cn } from "@/lib/utils";

// Single source of truth for the checkout action → Stripe Payment Link.
export const BuyButton = ({
  children = "Buy now",
  className = "",
  variant = "dark",
  testId = "buy-now-btn",
  ...props
}) => {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-tight " +
    "transition-transform duration-200 active:scale-95 focus:outline-none focus-visible:ring-2 " +
    "focus-visible:ring-offset-2 focus-visible:ring-ink";
  const variants = {
    dark: "bg-ink text-white hover:-translate-y-0.5 shadow-[0_10px_30px_rgba(0,0,0,0.12)]",
    light: "bg-white text-ink hover:-translate-y-0.5 shadow-[0_10px_30px_rgba(0,0,0,0.10)]",
    outline: "border border-ink/15 text-ink hover:bg-ink hover:text-white",
  };
  return (
    <a
      href={SITE.STRIPE_PAYMENT_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={cn(base, variants[variant], className)}
      {...props}
    >
      {children}
    </a>
  );
};
